import {
  call, put, select, takeLatest, takeEvery, all,
} from 'redux-saga/effects';
import callAdapter, { callAdapterResponseError } from '@/utils/sagaHelper';
import {
  findWithCodes,
  findWithReadStatus,
  successAndErrors,
  successAndErrorsOnDestroy,
  wildcardFilter,
} from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import selectors from '@/selectors';
import TokensService from '../service';
import {
  showTokens,
  showTokensError,
  newToken,
  newTokenError,
  destroyToken,
  destroyTokenError,
  disableTokenError,
  disableTokenSuccess,
} from '../actions';
import actions, { tokenLists } from '../constants';
import myTokens from '../helper';

export function* tokens(action) {
  const items = yield select(selectors.tokens);
  const auth = yield select(selectors.auth);
  const user = action.category === 'admin' ? null : auth.currentUser;

  const {
    filter, pageSize, currentPage, activeFlag, expiredFlag, systemFlag,
  } = items[action.category];

  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const includeActive = action.activeFlag || activeFlag;
  const includeExpired = action.expiredFlag || expiredFlag;
  const includeSystem = action.systemFlag || !user ? true : systemFlag;
  const { response, error } = yield call(callAdapter, TokensService.tokens(
    wildcardFilter(filter),
    includeActive,
    includeExpired,
    includeSystem,
    page,
    size,
    user,
  ));

  if (error) {
    yield put(showTokensError(action.category, error));
  } else {
    yield put(showTokens(
      action.category,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
      action.jwtCode,
      action.jwt,
    ));
  }
}

export function* create() {
  const item = yield select(selectors.activeToken);
  const auth = yield select(selectors.auth);

  const { response, error } = yield call(callAdapter, TokensService.create(item, auth.currentUser));
  if (error) {
    yield put(newTokenError(error));
  } else {
    const items = yield select(selectors.tokens);
    const toRefresh = findWithReadStatus(items, tokenLists, states.SUCCESS);

    const { jwt, code } = response;
    yield put(newToken(response));
    yield all(toRefresh.map((category) => tokens({ category, jwtCode: code, jwt })));
  }
}

export function* destroy(action) {
  const auth = yield select(selectors.auth);
  const user = myTokens(action.category) ? auth.currentUser : null;
  const results = yield all(action.items.map((i) => callAdapterResponseError(i, TokensService.destroy(i, user))));
  const { success, errors } = successAndErrorsOnDestroy(results, 'Token not found');

  if (errors.length > 0) {
    yield put(destroyTokenError(errors));
  }
  if (success.length > 0) {
    const items = yield select(selectors.tokens);
    const codes = success.map((item) => item.code);
    const categories = findWithCodes(items, tokenLists, codes);
    const toRefresh = findWithReadStatus(items, categories, states.SUCCESS);

    yield put(destroyToken(success));
    yield all(toRefresh.map((category) => tokens({ category })));
  }
}

export function* disable({ category, items }) {
  const auth = yield select(selectors.auth);
  const user = myTokens(category) ? auth.currentUser : null;
  const results = yield all(items.map((i) => callAdapterResponseError(i, TokensService.disable(i, user))));
  const { success, errors } = successAndErrors(results);

  if (errors.length > 0) {
    yield put(disableTokenError(errors));
  }
  if (success.length > 0) {
    yield put(disableTokenSuccess(success));
  }
}

export default function* tokensApi() {
  yield takeEvery([actions.FETCH_TOKENS, actions.REFRESH_TOKENS, actions.UPDATE_TOKENS_FLAGS], tokens);
  yield takeLatest(actions.CREATE_TOKEN, create);
  yield takeEvery(actions.DELETE_TOKEN, destroy);
  yield takeEvery(actions.DISABLE_TOKEN, disable);
}
